import React, { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useReportContext } from '../../../hooks/useReport';
import Spinner from '../../Spinner/Spinner';
import { SpinnerCont } from '../ReportLayout.styles';
import { Wrapper } from '../EffectReportDetails/EffectReportDetails.styles';
import { ResultTableTitle } from '../EffectReportDetails/ReportEffectResults/ReportEffectResults.styles';
import EffectAverageMeter from '../EffectReportDetails/ReportEffectResults/EffectAverageMeter/EffectAverageMeter';
import EffectReportTemplate from '../SharedEffectReportComponents/EffectReportTemplate/EffectReportTemplate';

const GoodTeamReportDetails = () => {
  const { getReportDetails, effectData, isLoading } = useReportContext();
  const { reportId } = useParams();

  const allTopicsAnalysis = useMemo(
    () => effectData?.analysis.find(item => item.type === 'GOOD TEAM ALL TOPICS'),
    [effectData]
  );

  useEffect(() => {
    (async () => {
      await getReportDetails(reportId || '0');
    })();
  }, [reportId]);

  if (!effectData && isLoading) {
    return (
      <SpinnerCont id="SpinnerCont">
        <Spinner size="large" />
      </SpinnerCont>
    );
  }

  return (
    <Wrapper>
      <ResultTableTitle>
        {effectData?.average?.average ? <EffectAverageMeter average={effectData.average} /> : null}
        {allTopicsAnalysis ? <EffectReportTemplate data={allTopicsAnalysis} /> : null}
      </ResultTableTitle>
    </Wrapper>
  );
};

export default GoodTeamReportDetails;
